import { useTranslation } from '@/hooks/useTranslation';

type BaseMetricLabel =
  | 'Sales'
  | 'Book'
  | 'Earnings'
  | 'Forecasted Earnings in 12m'
  | 'Forecasted Sales in 12m';

export const useBaseMetricLabel = () => {
  const t = useTranslation();
  return (metricLabel: BaseMetricLabel) => {
    switch (metricLabel) {
      case 'Sales':
        return t('page.companyReport.valuation.keyMetric.psBaseMetric');
      case 'Book':
        return t('page.companyReport.valuation.keyMetric.pbBaseMetric');
      case 'Forecasted Earnings in 12m':
        return t('page.companyReport.valuation.keyMetric.forwardPEBaseMetric');
      case 'Forecasted Sales in 12m':
        return t('page.companyReport.valuation.keyMetric.forwardPSBaseMetric');
      case 'Earnings':
        return t('page.companyReport.valuation.keyMetric.peBaseMetric');
    }
  };
};

export const useCalculatedBaseMetricLabel = () => {
  const t = useTranslation();
  return (metricLabel: BaseMetricLabel) => {
    switch (metricLabel) {
      case 'Sales':
        return t(
          'page.companyReport.valuation.keyMetric.psBaseCalculatedMetric'
        );
      case 'Book':
        return t(
          'page.companyReport.valuation.keyMetric.pbBaseCalculatedMetric'
        );
      case 'Forecasted Earnings in 12m':
        return t(
          'page.companyReport.valuation.keyMetric.forwardPEBaseCalculatedMetric'
        );
      case 'Forecasted Sales in 12m':
        return t(
          'page.companyReport.valuation.keyMetric.forwardPSBaseCalculatedMetric'
        );
      case 'Earnings':
        return t(
          'page.companyReport.valuation.keyMetric.peBaseCalculatedMetric'
        );
      default:
        return t(
          'page.companyReport.valuation.keyMetric.defaultBaseCalculatedMetric'
        );
    }
  };
};

export const useMetricRatioLabel = () => {
  const t = useTranslation();
  return (metric: 'PB' | 'PS' | 'Forward PS' | 'PE' | 'Forward PE' | 'n/a') => {
    switch (metric) {
      case 'PB':
        return t('page.companyReport.valuation.keyMetric.pbRatio');
      case 'PS':
        return t('page.companyReport.valuation.keyMetric.psRatio');
      case 'Forward PS':
        return t('page.companyReport.valuation.keyMetric.forwardPSRatio');
      case 'PE':
        return t('page.companyReport.valuation.keyMetric.peRatio');
      case 'Forward PE':
        return t('page.companyReport.valuation.keyMetric.forwardPERatio');
      case 'n/a':
        return t('page.companyReport.valuation.keyMetric.notAvailable');
    }
  };
};
